import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import ClassNames from "classnames";

const styles = theme => ({
  container: {
    margin: "8px 0",
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing.unit
    }
  },
  button: {
    margin: theme.spacing.unit / 2,
    boxShadow: "none"
  },
  selected: {
    color: "white"
  }
});
class ContainedButtons extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      conditions: {
        question: true,
        blog: true,
        nihon: true,
        seiyou: true,
      }
    }
  }
  handleClick = (type) => {
    const conditions = this.state.conditions
    let newConditions
    switch (type) {
      case 'Q':
        const question = !conditions.question
        if (question || conditions.blog) {
          newConditions = {
            ...conditions,
            question,
          }
        }
        break
      case 'B':
        const blog = !conditions.blog
        if (blog || conditions.question) {
          newConditions = {
            ...conditions,
            blog,
          }
        }
        break
      case 'N':
        const nihon = !conditions.nihon
        if (nihon || conditions.seiyou) {
          newConditions = {
            ...conditions,
            nihon,
          }
        }
        break
      case 'S':
        const seiyou = !conditions.seiyou
        if (seiyou || conditions.nihon) {
          newConditions = {
            ...conditions,
            seiyou,
          }
        }
        break
      default:
    }
    if (newConditions) {
      this.setState({
        conditions: newConditions,
      })
      this.props.filter(newConditions)
    }
  }
  render() {
    const { classes } = this.props;
    const conditions = this.state.conditions
    return (
      <React.Fragment>
        <Grid className={classes.container}>
          <div className={classes.titleBox}>投稿の種類で絞り込む:</div>
          <Button
            variant={ conditions.question ? "contained" : "outlined"}
            color={conditions.question ? "secondary" : null}
            className={ClassNames(
              classes.button,
              {[classes.selected]: conditions.question})
            }
            onClick={() => this.handleClick('Q')}
            >
            質問
          </Button>
          <Button
            variant={conditions.blog ? "contained" : "outlined"}
            color={conditions.blog ? "secondary" : null}
            className={ClassNames(
              classes.button,
              {[classes.selected]: conditions.blog}
            )}
            onClick={() => this.handleClick('B')}
          >
            日誌
          </Button>
        </Grid>
        <Grid className={classes.container}>
          <div className={classes.titleBox}>カテゴリで絞り込む:</div>
          <Button
            variant={conditions.nihon ? "contained" : "outlined"}
            color={conditions.nihon ? "secondary" : null}
            className={ClassNames(
              classes.button,
              {[classes.selected]: conditions.nihon}
            )}
            onClick={() => this.handleClick('N')}
          >
            ニホンミツバチ
          </Button>
          <Button
            variant={conditions.seiyou ? "contained" : "outlined"}
            color={conditions.seiyou ? "secondary" : null}
            className={ClassNames(
              classes.button,
              {[classes.selected]: conditions.seiyou}
            )}
            onClick={() => this.handleClick('S')}
          >
            セイヨウミツバチ
          </Button>
        </Grid>
      </React.Fragment>
    );
  }
}

ContainedButtons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ContainedButtons);
